import { Exception } from "./Exception";
export class ArgumentNullException extends Exception {
    constructor(argumentName, innerException) {
        super(`ArgumentNullException: ${argumentName}`, innerException);
    }
}
